import { Injectable } from '@angular/core';
import {ApiService} from '../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class RazonSocialService {

    constructor(private api: ApiService) { }

    findAllRazonSocial(term: string = ''): Observable<any>{
        return this.api.get('razon-social', {'comercial_name' : term});
    }

    findRsCamps(pkRs: number): Observable<any> {
        return this.api.get('razon-social/' + pkRs + '/campaigns');
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/shared/service/razon-social.service.ts